export const INITIAL_THREAD_MESSAGES_PAGE_SIZE = 50;
